import React, { FC, useMemo } from 'react';
import { connect } from 'react-redux';
import { DatePicker, Select } from 'antd';
import moment from 'moment';
import { defaultTimeZone } from '../../utils/DataConstants';

require('./OWDatePickerWIthTimeZone.less');

const OWDatePickerWithTimeZone: FC<any> = ({
	disabledStart = moment('1/1/1970', 'MM/DD/YYYY'),
	disabledEnd = moment('1/1/2038', 'MM/DD/YYYY'),
	paramName = 'startAndEndDates',
	timeZoneParamName = 'timeZone',
	otherDisabledDates = [],
	initialStartDate,
	initialEndDate,
	initialTimeZone,
	form,
	showTimeZone = false,
	rules,
	...props
}) => {
	const myTimeZone = moment.tz.guess();
	const myTimeZoneAbbreviation = moment.tz(new Date(), moment.tz.guess()).format('z');
	const defaultTimeZoneAbbreviation = moment.tz(new Date(), defaultTimeZone).format('z');

	const timeZone = useMemo(() => initialTimeZone || myTimeZone, [initialTimeZone]);

	const disabledDate = (current) => {
		// Can not select days greater/less than database can handle
		return (
			current &&
			(current > disabledEnd ||
				current < disabledStart ||
				otherDisabledDates.some((d) => d === current))
		);
	};

	return (
		<span>
			{form.getFieldDecorator(paramName, {
				...(rules ? { rules } : {}),
				initialValue:
					initialStartDate || initialEndDate
						? [
								initialStartDate && moment(initialStartDate),
								initialEndDate && moment(initialEndDate),
						  ]
						: undefined,
			})(
				<DatePicker.RangePicker
					{...props}
					disabledDate={disabledDate}
					style={showTimeZone ? { borderRadius: '2px 0px 0px 2px' } : {}}
				/>
			)}
			{showTimeZone
				? form.getFieldDecorator(timeZoneParamName, {
						initialValue: timeZone,
				  })(
						<Select
							className="tz-select"
							style={{
								display: 'inline-flex',
								alignItems: 'center',
								whiteSpace: 'nowrap',
								width: 75,
								marginLeft: -1,
								borderRadius: '0px 2px 2px 0px',
							}}
						>
							<Select.Option value={myTimeZone} label={myTimeZoneAbbreviation}>
								{myTimeZoneAbbreviation}
							</Select.Option>
							<Select.Option value={defaultTimeZone} label={defaultTimeZoneAbbreviation}>
								{defaultTimeZoneAbbreviation}
							</Select.Option>
						</Select>
				  )
				: null}
		</span>
	);
};

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(OWDatePickerWithTimeZone);
